
<style>
    .card-header-formatting {
      background: linear-gradient(112.2deg, var(--sl-color-primary-400) 14.86%, var(--sl-color-primary-700) 102.08%);
      color: white;
    }
    .error {
    color: #ff4444;
    }
    .horn{
    height: 170px;
    width: 170px;
    fill: linear-gradient(112.2deg, var(--sl-color-primary-400) 14.86%, var(--sl-color-primary-700) 102.08%);
    }
    
</style>  

<fadv-loader *ngIf="loading" [duration]="2200" [open]="true"></fadv-loader>

<fadv-box *ngIf="!success" pv="x-large" ph="xxx-large">
    <form [formGroup]="form" (ngSubmit)="onSubmit()">
        <fadv-card>
            <fadv-card-header>
            <div class="card-header-formatting">
                <fadv-box p="large">
                    <fadv-typography style="text-align: center" type="heading-small" variant="white">Your First Background Check Is On Us. <br /> Sign Up Now.</fadv-typography>
                </fadv-box>
            </div>
            </fadv-card-header>
            <fadv-card-body>
                <fadv-box p="large">

                    <fadv-box pb="medium">
                        <fadv-typography style="text-align: center;" type="paragraph-medium" variant="neutral" >
                            To get started, please enter your information below.  Be sure to provide your company e-mail address, we’ll need that info to connect to your account.
                        </fadv-typography>
                    </fadv-box>

                    <fadv-input (blur)="form.get('firstName').markAsDirty()" id="firstName" label="First Name *" 
                    name="firstName" type="text"  variant="primary" formControlName="firstName" [invalid]="form.get('firstName')?.invalid && form.get('firstName')?.dirty">
                    </fadv-input>
                    <span class="error" *ngIf="form.get('firstName').invalid && form.get('firstName').dirty">
                        <small *ngIf="form.get('firstName').hasError('required')">First name is required</small>
                        <small *ngIf="form.get('firstName').hasError('pattern')">First name cannot contain numbers or special characters</small>
                        <small *ngIf="form.get('firstName').hasError('whitespace') && !form.get('firstName').hasError('required')">First name cannot be empty</small>
                    </span>

                    <fadv-input (blur)="form.get('lastName').markAsDirty()"  id="lastName" label="Last Name *" 
                    name="lastName" type="text"  variant="primary" formControlName="lastName" [invalid]="form.get('lastName')?.invalid && form.get('lastName')?.dirty">
                    </fadv-input>
                    <span class="error" *ngIf="form.get('lastName').invalid && form.get('lastName').dirty">
                        <small *ngIf="form.get('lastName').hasError('required')">Last name is required</small>
                        <small *ngIf="form.get('lastName').hasError('pattern')">Last name cannot contain numbers or special characters</small>
                        <small *ngIf="form.get('lastName').hasError('whitespace') && !form.get('lastName').hasError('required')">Last name cannot be empty</small>
                    </span>

                    <fadv-input (blur)="form.get('companyName').markAsDirty()" id="companyName" label="Company Name *" 
                    name="companyName" type="text"  variant="primary" formControlName="companyName" [invalid]="form.get('companyName')?.invalid && form.get('companyName')?.dirty">
                    </fadv-input>
                    <span class="error" *ngIf="form.get('companyName').invalid && form.get('companyName').dirty">
                        <small *ngIf="form.get('companyName').hasError('required')">Company name is required</small>
                        <small *ngIf="form.get('companyName').hasError('whitespace') && !form.get('companyName').hasError('required')">Company name cannot be empty</small>
                    </span>


                    <fadv-input (blur)="handleEmailBlur()" inputmode="email" 
                    id="email" label="Company Email Address *" name="email" type="email" variant="primary" formControlName="email">
                    </fadv-input>
                    <span class="error" *ngIf="form.get('email').invalid && form.get('email').dirty">
                        <small *ngIf="form.get('email').hasError('required')">Email is required</small>
                        <small *ngIf="emailInvalid && !form.get('email').hasError('required')">Valid email is required</small>
                    </span>

                    <fadv-grid>
                        <fadv-grid-row>
                            <fadv-grid-col alignment="center">
                                <fadv-box pt="medium">
                                    <fadv-button [loading]="loading" [active]="loading" [disabled]="form.invalid || loading" size="medium"
                                    variant="primary" (click)="onSubmit()" type="button" name="free-background-register-button">Register</fadv-button>
                                </fadv-box>
                            </fadv-grid-col>
                        </fadv-grid-row>    
                    </fadv-grid>

                </fadv-box>
            </fadv-card-body>
        </fadv-card>
    </form>
</fadv-box>

<fadv-box *ngIf="success" pv="x-large" ph="xxx-large">
    <fadv-typography style="text-align: center"><img class="horn" src="/assets/img/iconmonstr-party.svg"/></fadv-typography>
    <fadv-typography style="text-align: center" type="heading-large" variant="primary">Success!</fadv-typography>
    <fadv-box pv="large">
        <fadv-typography style="text-align: center; padding: 0px 75px" type="paragraph-medium" variant="neutral">
            Thank you for signing up with First Advantage Background Direct. We're excited to include you in our exclusive promotion for a free background check! Watch your inbox for a link to complete next steps in registering your account and ordering your free background check.
        </fadv-typography>
    </fadv-box>
</fadv-box>
